<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="扇区边框">
      <t-color-picker :colorModes="['monochrome']" format="HEX" @change="onChangeColor" enableAlpha size="small" v-model="attribute.borderColor"/>
    </t-form-item>
    <t-form-item label="配色">
      <e-color-group v-model="attribute.pieColor" :max="20" :gradient="false"/>
    </t-form-item>
    <t-form-item label="内边框配色">
      <e-color-group v-model="attribute.pieColor2" :max="20" :gradient="false"/>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
import EColorGroup from "@/components/designer/e-color-group";
export default {
  name: "cpt-ring-pie-option",
  components: {EColorGroup,CptData},
  props: { attribute: Object,cptDataForm:Object, },
  methods: {
    onChangeColor(color,type) {
      this.attribute.borderColor = type.color.css
    }
  }
}
</script>

<style scoped>
</style>
